import $ from 'jquery';
import moment from 'moment';
import './notify.min';
import { reportsRepo } from './reportsRepo';

// A $( document ).ready() block.
$(document).ready(function () {
    reportsRepo.checkRollupStatus().then(function (e) {

        if (e.isRunning == true) {
            $.notify.addStyle('redalert', {
                html: "<div class=\"rollupnotification\"><div class=\"rollupnotification\"><strong>Rollup In Progress</strong><span data-notify-text/>Data may be incomplete or incorrect until rollup is complete.</div></div>",
                classes: {
                    base: {


                        "padding": "5px",
                        "z-index": 1,
                        "font-size": ""
                    },
                    superblue: {


                        "border": "1px solid transparent",
                        "border-radius": "5px",
                        "z-index": 1,
                        "font-size": ""
                    }
                }
            });

            $.notify(" ", { globalPosition: 'top center', style: "redalert", autoHide: false });
        }

        if (e.lastRolledUpDate) {
            var el = document.getElementById('lastUpdated');
            if (el)
                el.innerHTML = "Last Import:  " + moment(e.lastRolledUpDate).format("MM/DD/YYYY");
        }
        
        console.log(e);

    });

});